import React, { useState } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import VideoWebcamRecorder from './Recorder';
import './Celebrate.css';


/**
 * Plays the celebrate video module shown at the end of each day
 * @param {*} props
 * @returns the HTML code for the celebrate module
 */
export default function Celebrate(props) {
  // Initialize variables to be used later
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const dispatch = useDispatch();
  const [displayCelebrateAfterVideo, setDisplayCelebrateAfterVideo] = useState(false);
  const [displayCelebrateRecord, setDisplayCelebrateRecord] = useState(true);
  const [audioReady, setAudioReady] = useState(false);
  const [animalSize, setAnimalSize] = useState(props.bigAnimal  ? (props.lizard ? 'lizard' : 'bigAnimal') : 'animateAnimal15')
  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

  const videoPlayer = {
    minWidth: '100%',
    minHeight: '100%',
    position: 'relative',
  };
  const [Exit] = useState(
    generateImageUrl('images/Images/close.png')
  );

  // The actual HTML code that determines whether to show the module above.
  return (
    <>
        {displayCelebrateRecord && (
            <VideoWebcamRecorder
                background={props.background}
                outputText={props.text}
                name={props.name}
                setDisplayCelebrateAfterVideo={setDisplayCelebrateAfterVideo}
                setDisplayCelebrateRecord={setDisplayCelebrateRecord}
                animal={props.animal}
                voice1={props.voice1}
                level1={props.level1}
                close={props.setDisplayCelebrate}
            />
        )}
        {displayCelebrateAfterVideo && (
            <audio
                autoPlay
                onPlay={() => {
                setAudioReady(true);
                }}
                onEnded={() => props.close()}
            >
                <source src={props.voice2}></source>
            </audio>
        )}
        {displayCelebrateAfterVideo && (
            <img
                alt='animation'
                className= {animalSize}
                style={audioReady ? {} : { display: 'none' }}
                src={props.animation}
            />
        )}
    </>

  )
}
